import { FC, ReactNode } from "react";
import { cx } from "@jugl-web/utils";
import { Dialog } from "../../cross-platform/Dialog";
import { PlainButton } from "../../cross-platform/PlainButton";
import { ReactComponent as CloseIcon } from "./assets/close.svg";
import heroBackground from "./assets/background.png";

export interface DialogWithHeroProps {
  isOpen: boolean;
  onClose: () => void;
  upperTitle: ReactNode;
  title: ReactNode;
  description: ReactNode;
  headerChildren?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export const DialogWithHero: FC<DialogWithHeroProps> = ({
  isOpen,
  onClose,
  upperTitle,
  title,
  description,
  headerChildren,
  children,
  className,
}) => (
  <Dialog
    isOpen={isOpen}
    onClose={onClose}
    className={cx(
      "flex w-full max-w-[780px] overflow-hidden rounded-2xl",
      className
    )}
  >
    <PlainButton
      className="absolute top-6 right-6 z-10 flex h-8 w-8 items-center justify-center rounded-lg bg-dark/20 backdrop-blur-sm"
      onClick={onClose}
    >
      <CloseIcon />
    </PlainButton>
    <div className="jugl__custom-scrollbar flex w-full flex-col overflow-y-auto overscroll-none">
      <div className="relative flex shrink-0 flex-col items-center pt-20 pb-16">
        <img
          src={heroBackground}
          alt=""
          className="absolute inset-0 -z-10 h-full w-full object-cover"
          role="presentation"
        />
        <span className="font-secondary text-sm font-light text-grey-200">
          {upperTitle}
        </span>
        <div className="mt-6 flex items-center gap-3">{title}</div>
        <p className="mt-4 max-w-[500px] text-center font-secondary text-sm leading-[1.5] text-grey-200">
          {description}
        </p>
        {headerChildren || null}
      </div>
      {children != null && (
        <div className="flex-1 px-8 pt-6 pb-8">{children}</div>
      )}
    </div>
  </Dialog>
);
